import type { ModalCloseReason } from '~/components/StandardModal/types';
import {
  type ModalProperties,
  type ModalScreen,
  toModalProperties
} from '~/utils/modalProperties';

import InteractionEvent, {
  type InteractionTargetType
} from './InteractionEvent';

export type DismissPlacement = ModalCloseReason | 'dismiss_button';

// Which banner was closed. A banner's seen record is its click's type, so dbt joins a dismiss to
// it on view_id and this value: app_download is the navigation_link impression at app_banner,
// notification the notification impression at banner.
export type DismissBannerType = 'app_download' | 'notification';

export type DismissTargetProperties = { placement: DismissPlacement } & (
  | { banner_type: DismissBannerType }
  | ModalProperties
);

type DismissedThing =
  | { bannerType: DismissBannerType }
  | { modal: ModalScreen };

type EventData = DismissedThing & {
  gesture?: string;
  guestId?: string;
  isBot: boolean;
  placement: DismissPlacement;
};

class DismissInteractionEvent extends InteractionEvent<
  EventData,
  DismissTargetProperties
> {
  protected get targetType(): InteractionTargetType {
    return 'dismiss';
  }

  protected getTargetProperties(): DismissTargetProperties {
    const { placement } = this.data;

    if ('modal' in this.data)
      return { ...toModalProperties(this.data.modal), placement };

    return { banner_type: this.data.bannerType, placement };
  }
}

export default DismissInteractionEvent;
